import type { PermitResponse } from '@contracts/permitSearch/PermitListResponse';
import type { GridApi } from '@mui/x-data-grid-pro';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { PdfExportButton } from '@src/permits/PdfExportButtons';
import { CsvExportButton } from '@src/reports/CsvExportButton';

interface Props {
  permits: PermitResponse[];
  gridApiRef: React.MutableRefObject<GridApi>;
}

export const PermitSearchExportButtons = ({ permits, gridApiRef }: Props) => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="start"
        gap={theme.spacing['2']}
        paddingX={theme.spacing['5']}
        marginTop={`-${theme.spacing['5']}`}
        paddingBottom={theme.spacing['3']}
      >
        <PdfExportButton permits={permits} gridApiRef={gridApiRef} />
        <CsvExportButton permits={permits} gridApiRef={gridApiRef} />
      </Stack>
    </>
  );
};
